<template>
  <!-- <div style="width: 1400px;margin: 20px auto;background-color: #fff;padding: 30px;" v-html="about_us"> -->
  <div style="width: 1400px; margin: 20px auto; padding: 30px;align-items: normal;" class="u-flex">
    <div style="width: 200px; height: 200px; background: #ffffff;line-height: 67px;">
	<div v-for="(item,index) in list" :class="{'select':current==index}" @click="itemClick(index)" :key="index" style="padding-left: 34px;font-size: 16px;">{{item}}</div>
	</div>
    <div style="width: 1180px; height: 940px; background: #ffffff;margin-left: 20px;padding: 30px;">
<div v-html="about_us" v-show="current==0"></div>
<div v-html="copyright" v-show="current==1"></div>
<div v-html="privacy" v-show="current==2"></div>
	</div>

  </div>
</template>

<script>
export default {
  data() {
    return {
		list:['关于我们','版权声明','隐私保护'],
      about_us: "",
	  copyright:'',
	  privacy:'',
	  current:0
    };
  },
  created() {
    this.getdata();
  },
  methods: {
	itemClick(index){
		if(this.current!=index){
			this.current=index
		}
	},
    getdata() {
      this.$http({
        url: "/api/Publics/config_info",
      }).then((res) => {
        this.about_us = res.data.about_us;
        this.copyright = res.data.copyright;
        this.privacy = res.data.privacy;
      });
    },
  },
};
</script>

<style lang="scss">
.select{
	position: relative;
	
}
.select::before{
		content: '';
		position: absolute;
		top:50%;
		transform: translateY(-50%);
		left:0;
		width: 4px;
height: 34px;
background: #1C6AFF;
}

</style>
